import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51bec1e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cards mt-0" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "slogan" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-truck" }, null, -1))
const _hoisted_5 = { class: "shopButton" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Explore More")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("slogan")), 1)
      ]),
      _createVNode(_component_ProductList, { favourites: true }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/shopping",
          class: "btn shopBtn"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}